import React from "react";
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Badge, Table, Row, Col, Card, CardBody,
} from "reactstrap";
import { generateSeatsPDF } from "./SeatsPDF";

const SeatsModal = ({ isOpen, toggle, assignment, seats = [], seatsStats = null }) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
            <ModalHeader toggle={toggle}>
                Liste des places —{" "}
                <span className="text-primary">
                    {assignment?.exam_room?.name}
                </span>
                <span className="text-muted ms-2 fw-normal small">
                    {assignment?.date} · {assignment?.start_time} → {assignment?.end_time}
                </span>
            </ModalHeader>

            <ModalBody>
                {/* Stats */}
                {seatsStats && (
                    <Row className="mb-3">
                        {[
                            { label: "Total places",   val: seatsStats.total_seats,   color: "primary" },
                            { label: "Capacité salle", val: seatsStats.capacity,       color: "info"    },
                            { label: "Places libres",  val: seatsStats.places_libres,  color: "success" },
                        ].map((s, i) => (
                            <Col key={i} md={4}>
                                <Card className={`border-${s.color} border-start border-4`}>
                                    <CardBody className="py-2">
                                        <div className="text-muted small">{s.label}</div>
                                        <div className={`fs-4 fw-semibold text-${s.color}`}>
                                            {s.val}
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}

                {/* Tableau des places */}
                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <Table bordered size="sm" responsive>
                        <thead className="table-light sticky-top">
                            <tr>
                                <th style={{ width: "80px" }}>Place N°</th>
                                <th>Matricule</th>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th>Sexe</th>
                                <th>Classe</th>
                            </tr>
                        </thead>
                        <tbody>
                            {seats.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted py-3">
                                        Aucune place attribuée
                                    </td>
                                </tr>
                            ) : (
                                seats.map((seat) => (
                                    <tr
                                        key={seat.seat_number}
                                        style={{
                                            backgroundColor: seat.seat_number % 2 === 0
                                                ? "#f8f9fa"
                                                : "#fff"
                                        }}
                                    >
                                        <td className="text-center fw-bold">
                                            {seat.seat_number}
                                        </td>
                                        <td className="font-monospace small">
                                            {seat.student?.student_number ?? "-"}
                                        </td>
                                        <td className="fw-bold">
                                            {seat.student?.last_name ?? "-"}
                                        </td>
                                        <td>{seat.student?.first_name ?? "-"}</td>
                                        <td>{seat.student?.sex ?? "-"}</td>
                                        <td>
                                            <Badge color="primary" className="fw-normal">
                                                {seat.study_level?.name ?? "-"}
                                            </Badge>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" outline onClick={toggle}>
                    Fermer
                </Button>
                <Button
                    color="success"
                    onClick={() => generateSeatsPDF({ assignment, seats, seatsStats })}
                    disabled={seats.length === 0}
                >
                    Imprimer la liste
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SeatsModal;